var _defs, _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8, _g9, _path2, _path3, _path4, _path5, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofenceLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e9bd98f1d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "885daf5e6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 100.757812 0 30.4375 70.320312 30.4375 157.0625 C 30.4375 243.804688 100.757812 314.125 187.5 314.125 C 274.242188 314.125 344.5625 243.804688 344.5625 157.0625 C 344.5625 70.320312 274.242188 0 187.5 0 Z M 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2041ef268c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.125 270.328125 L 295.875 270.328125 L 295.875 375 L 79.125 375 Z M 79.125 270.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "27cce478d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 375 L 295.875 270.328125 L 79.125 270.328125 Z M 187.5 375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ca817937e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58ab487b64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 8.738281 C 104.800781 8.738281 37.757812 75.78125 37.757812 158.480469 C 37.757812 241.179688 104.800781 308.222656 187.5 308.222656 C 270.199219 308.222656 337.242188 241.179688 337.242188 158.480469 C 337.242188 75.78125 270.199219 8.738281 187.5 8.738281 Z M 187.5 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d12d84a951"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.175781 266.46875 L 290.824219 266.46875 L 290.824219 366.261719 L 84.175781 366.261719 Z M 84.175781 266.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "48b962f991"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 366.261719 L 290.824219 266.46875 L 84.175781 266.46875 Z M 187.5 366.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3c4572213a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "116183d2b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 19.507812 C 110.746094 19.507812 48.527344 81.726562 48.527344 158.480469 C 48.527344 235.234375 110.746094 297.453125 187.5 297.453125 C 264.253906 297.453125 326.472656 235.234375 326.472656 158.480469 C 326.472656 81.726562 264.253906 19.507812 187.5 19.507812 Z M 187.5 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c453e54d97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 162.855469 54.667969 L 189.5625 54.667969 L 189.5625 81.375 L 162.855469 81.375 Z M 162.855469 54.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1418f727ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 176.210938 54.667969 C 168.835938 54.667969 162.855469 60.644531 162.855469 68.023438 C 162.855469 75.398438 168.835938 81.375 176.210938 81.375 C 183.585938 81.375 189.5625 75.398438 189.5625 68.023438 C 189.5625 60.644531 183.585938 54.667969 176.210938 54.667969 Z M 176.210938 54.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b378ab5821"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 245.179688 81.539062 L 272.511719 81.539062 L 272.511719 108.875 L 245.179688 108.875 Z M 245.179688 81.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c80fe0165b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258.84375 81.539062 C 251.296875 81.539062 245.179688 87.660156 245.179688 95.207031 C 245.179688 102.753906 251.296875 108.875 258.84375 108.875 C 266.394531 108.875 272.511719 102.753906 272.511719 95.207031 C 272.511719 87.660156 266.394531 81.539062 258.84375 81.539062 Z M 258.84375 81.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a821927779"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 190.667969 232.484375 L 217.902344 232.484375 L 217.902344 259.71875 L 190.667969 259.71875 Z M 190.667969 232.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ec8e679a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.285156 232.484375 C 196.765625 232.484375 190.667969 238.582031 190.667969 246.101562 C 190.667969 253.621094 196.765625 259.71875 204.285156 259.71875 C 211.808594 259.71875 217.902344 253.621094 217.902344 246.101562 C 217.902344 238.582031 211.808594 232.484375 204.285156 232.484375 Z M 204.285156 232.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2226af72d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.5625 176.992188 L 118.550781 176.992188 L 118.550781 203.984375 L 91.5625 203.984375 Z M 91.5625 176.992188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe57dafd1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.054688 176.992188 C 97.601562 176.992188 91.5625 183.035156 91.5625 190.488281 C 91.5625 197.941406 97.601562 203.984375 105.054688 203.984375 C 112.507812 203.984375 118.550781 197.941406 118.550781 190.488281 C 118.550781 183.035156 112.507812 176.992188 105.054688 176.992188 Z M 105.054688 176.992188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a113e61dd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 199.097656 110.203125 L 309.933594 110.203125 L 309.933594 179.179688 L 199.097656 179.179688 Z M 199.097656 110.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a475e75f9b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.933594 144.691406 L 270.898438 110.203125 L 270.898438 129.71875 L 199.097656 129.71875 L 199.097656 159.660156 L 270.898438 159.660156 L 270.898438 179.179688 Z M 309.933594 144.691406 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e9bd98f1d1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#885daf5e6e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2041ef268c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#27cce478d8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 79.125 270.328125 L 295.875 270.328125 L 295.875 375 L 79.125 375 Z M 79.125 270.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ca817937e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58ab487b64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d12d84a951)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#48b962f991)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 84.175781 266.46875 L 290.824219 266.46875 L 290.824219 366.261719 L 84.175781 366.261719 Z M 84.175781 266.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3c4572213a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#116183d2b3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.712437, 0.23438, -0.23438, 0.712437, 190.070382, 68.635601)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 5.000931 5.001672 L 74.952044 5.000819 ",
    stroke: "#000000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c453e54d97)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1418f727ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 162.855469 54.667969 L 189.5625 54.667969 L 189.5625 81.375 L 162.855469 81.375 Z M 162.855469 54.667969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b378ab5821)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c80fe0165b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 245.179688 81.539062 L 272.511719 81.539062 L 272.511719 108.875 L 245.179688 108.875 Z M 245.179688 81.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a821927779)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ec8e679a1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 190.667969 232.484375 L 217.902344 232.484375 L 217.902344 259.71875 L 190.667969 259.71875 Z M 190.667969 232.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2226af72d5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe57dafd1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 91.5625 176.992188 L 118.550781 176.992188 L 118.550781 203.984375 L 91.5625 203.984375 Z M 91.5625 176.992188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.654256, 0.366673, -0.366673, 0.654256, 118.66324, 193.818621)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 4.999567 4.998118 L 110.51028 4.99748 ",
    stroke: "#000000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.376774, -0.648491, 0.648491, 0.376774, 108.591648, 176.930379)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 5.002227 4.999899 L 148.044466 4.999695 ",
    stroke: "#000000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.252165, -0.706337, 0.706337, 0.252165, 248.24952, 113.731574)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 5.000139 5.001274 L 4.784323 5.000897 ",
    stroke: "#000000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.29329, -0.690276, 0.690276, 0.29329, 206.161001, 232.09809)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 4.999481 4.999199 L 85.624071 5.002212 ",
    stroke: "#000000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a113e61dd6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a475e75f9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 199.097656 110.203125 L 309.933594 110.203125 L 309.933594 179.179688 L 199.097656 179.179688 Z M 199.097656 110.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceLeave);
export default __webpack_public_path__ + "static/media/geofence_leave.8fc5ddf89e5d74cfbe0edd0e2977e12e.svg";
export { ForwardRef as ReactComponent };